export default () => ({
    init() {
        const observer = new IntersectionObserver((items) => {
            items.forEach((item) => {
                if (item.isIntersecting && !this.$wire.get('loadedAll')) {
                    this.$wire.call('loadMore');
                }
            })
        }, {
            root: null
        })
        observer.observe(this.$el)
    }
});
